module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/eEDAOB/image/Cover.jpg?1709919022845",
      "alt": "This image is the cover for the book The Owl Project"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Owl Project\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The OWL Project is a programme of activities to enable anybody working with primary school age children to help them to develop essential skills for social and emotional wellbeing through nature and gardening activities. If you want to get children outdoors but don’t know where to start, this book is for you. With step-by-step plans, this unique book gives you the tools you need to support children in the natural environment no matter how small your outside space or budget. The session plans include games, gardening activities, social skills starters, and resource suggestions. It is designed to be easy to read and even easier to implement and offers ideas for every season.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eloise Bruce\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Eloise Bruce is a mother of two, living in Hampshire in the UK. She had a long career as a primary school teacher and has been working in social and therapeutic horticulture for the past 5 years. Eloise is passionate about getting children learning outdoors and helping them to develop their social and emotional skills through a strong connection with nature. In her spare time, Eloise can be found pottering around in the garden, watching the birds and squirrels through the window or wandering about in the woods.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0